namespace Areas.Dialogs {
    "use strict";

    export class CreateDaUcopDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("CreateDaUcop", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#CreateDaUcopForm").dxForm("instance");
            const result: any = form.validate();
    
            if (result.isValid) {
                const newData: any = form.option("formData");
               
                sendRequest("/Dialog/CreateDaUcop/Post", JSON.stringify(newData), "POST");
            }
        } 
    }    
}